import { ILocalizable } from './localized';

export type ILegalNotice = {
  id: string;
  text: ILocalizable;
};

export type IPreference = {
  id: string;
  description: string;
  legalNotice: ILegalNotice;
};

export type IConsentPreference = {
  id: string;
  consentPreference: IPreference;
  date: Date | string;
};
